export default __webpack_public_path__ + "static/media/Erica_Pagnoni_Enchantress_30_x_30_cm.369cedcd.jpg";